// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__gbdim","box":"Switch_box__ctgiv","knob":"Switch_knob__r4May","label":"Switch_label__5m4Wb"};